module.exports = Object.freeze({
    STT: "STT",
    PAGE_NAME: "Tên màn",
    PAGE_FUNCTION: "Chức năng",
    SEARCH_PLACEHOLDER: 'Tìm kiếm theo tên màn hình',
    SAVE_SETTING: 'Lưu cài đặt',
    RESTORE_SETTING: 'Khôi phục mặc định',
    ADD: 'Thêm',
    EDIT: 'Sửa',
    DELETE: 'Xóa / Khôi phục',
    DOWNLOAD: 'Tải xuống',
    UPLOAD: 'Tải lên',
    EXPORT: 'Xuất file',
    READ: 'Xem',
    RESTORE: 'Khôi phục',
    CHECK_ALL: 'Chọn tất cả'
});